export const ORGANISATION_SUPPLIER_STATE_VALUES = ['ACTIVE', 'ARCHIVED', 'INACTIVE', 'PENDING'] as const
export type OrganisationSupplierState = (typeof ORGANISATION_SUPPLIER_STATE_VALUES)[number]

export const SUPPLIER_ONLINE_RESOURCE_STATUS_VALUES = ['public', 'private', 'unavailable', 'notFound'] as const
export type SupplierOnlineResourceStatus = (typeof SUPPLIER_ONLINE_RESOURCE_STATUS_VALUES)[number]

export const SUPPLIER_ONLINE_RESOURCE_TYPE_VALUES = [
  'trustCenter',
  'soc2',
  'iso27001',
  'privacyPolicy',
  'dpa',
  'penTestReport',
  'governmentBusinessRegistry',
  'subprocessorList',
  'csaStar',
  'pciDSS',
  'cyberEssentials',
  'statusPage',
] as const
export type SupplierOnlineResourceType = (typeof SUPPLIER_ONLINE_RESOURCE_TYPE_VALUES)[number]

export const INTERNAL_CONTACT_ROLE_VALUES = ['business-owner', 'it-owner', 'budget-holder', 'other'] as const
export type InternalContactRole = (typeof INTERNAL_CONTACT_ROLE_VALUES)[number]
